import { render, staticRenderFns } from "./fccConfiguracoes.vue?vue&type=template&id=4608536e"
import script from "./fccConfiguracoes.vue?vue&type=script&lang=js"
export * from "./fccConfiguracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports